<template>
  <div>
    <b-table-column v-for="(column, index) in columns" :key="index" v-bind="columnAttrs(column)" :sticky="isSticky(column)" :cell-class="getCellClass(column)" v-slot="{ row }">
      <div :class="{ 'column-with-feedback': column.attrs.feedback }" :data-private="column.attrs.phi ? '' : null">
        <template v-if="column.attrs.transformerTarget">
          <transformed-value :target="column.attrs.transformerTarget" :value="getTransformerValue(column, row)" />
        </template>
        <template v-else-if="column.attrs.isCustomField && column.attrs.customFieldKind == 'select'">
          <div class="custom-field--select background-color" :class="`background-color--${choiceColor(column, row)}`">
            {{ row.custom_fields[column.attrs.customFieldKey] || 'N/A' }}
          </div>
        </template>
        <template v-else-if="column.attrs.isCustomField && column.attrs.customFieldKind == 'checkbox'">
          {{ row.custom_fields[column.attrs.customFieldKey]?.join(', ') || 'N/A' }}
        </template>
        <template v-else-if="column.attrs.isCustomField && column.attrs.customFieldKind == 'datetime'">
          {{ row.custom_fields[column.attrs.customFieldKey] ? $helpers.formatDate(row.custom_fields[column.attrs.customFieldKey]) : 'N/A' }}
        </template>
        <template v-else-if="column.formatter">
          {{ column.formatter(row) }}
        </template>
        <slot v-else-if="column.usesSlot" :name="slotNameFor(column)" :row="row"></slot>
        <p v-else>N/A</p>
        <user-feedback-buttons
          v-if="column.attrs.feedback && showFeedback(column, row)"
          class="column-feedback"
          :feature="column.attrs.feedback.feature"
          :metadata="column.attrs.feedback.metadata(row)"
        />
      </div>
    </b-table-column>
  </div>
</template>

<script>
import TransformedValue from '@/components/transformers/TransformedValue.vue'
import UserFeedbackButtons from '@/components/UserFeedbackButtons.vue'

export default {
  name: "DynamicTableColumns",
  components: { TransformedValue, UserFeedbackButtons },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    columnSettings: {
      type: Object,
      default: () => { return {} }
    },
    customFieldsModel: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    // `phi` drives the cell's data-private attribute and is not a <b-table-column> prop
    columnAttrs(column) {
      // eslint-disable-next-line no-unused-vars
      const { phi, ...attrs } = column.attrs
      return attrs
    },
    getTransformerValue(column, row) {
      if (column.attrs.transformerRawValue) {
        return column.attrs.transformerRawValue(row)
      }
    },
    choiceColor(column, row) {
      if (!column.attrs?.customFieldOptions?.choiceColors) {
        return ''
      }
      return column.attrs.customFieldOptions?.choiceColors[row.custom_fields[column.attrs.customFieldKey]]
    },
    slotNameFor(column) {
      let name = 'field-'
      if (column.attrs.slotName) {
        name += column.attrs.slotName
      } else {
        name += column.attrs.field
      }
      return name
    },
    isSticky(column) {
      return !!this.columnSettings[column.attrs.field]?.is_sticky
    },
    isWrapped(column) {
      return !!this.columnSettings[column.attrs.field]?.is_wrapped
    },
    getCellClass(column) {
      const cssClasses = []
      if (column.attrs['cell-class']) {
        cssClasses.push(column.attrs['cell-class'])
      }
      if (this.isWrapped(column)) {
        cssClasses.push('wrap')
      }
      return cssClasses.join(' ')
    },
    showFeedback(column, row) {
      if (column.attrs.feedback.shouldShow) {
        return column.attrs.feedback.shouldShow(row)
      }

      return true
    }
  }
}
</script>

<style scoped lang="scss">
  .custom-field--select {
    display: inline-flex;
    padding: 3px 6px;
    border-radius: 4px;
  }

  .column-with-feedback {
    display: flex;
    align-items: center;
    gap: 8px;

    .column-feedback {
      opacity: 0;
      transition: opacity 0.15s;
      color: var(--ld-text-secondary);
    }

    &:hover .column-feedback {
      opacity: 1;
    }
  }
</style>
